import { combineReducers } from 'redux'
import listReducer, { listActions } from '@app-store/slices/categories/list'

export const categoriesReducer = combineReducers({
    list: listReducer
})

export const categoriesActions = {
    list: listActions
}
